import React, { useEffect } from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import { getPortalId, getFormId, getCourseAppObjectId } from '../../config/hubspotConfig';

const FormPersonalInformation = ({ fetchHubspotFormStatus, currentApplicant, courseApplicationData }) => {
  useEffect(() => {
    document.title = "Education and Employment | LaunchCode";
  }, []);

  const courseAppObjectId = getCourseAppObjectId();

  const { loaded, error, formCreated } = useHubspotForm({
    portalId: getPortalId(),
    formId: getFormId('employment'),
    target: '#course-application',
    onFormReady: function($form){
      var $theEmail = $form.find('input[name="email"]');
      var $course_application_unique_identifier = $form.find(`input[name="${courseAppObjectId}/course_application_unique_identifier"]`);
      var $course_application_name = $form.find(`input[name="${courseAppObjectId}/course_application_name"]`);
      
      $theEmail.val(currentApplicant.email).change();
      $course_application_unique_identifier.val(courseApplicationData.course_application.course_application_unique_identifier).change()
      $course_application_name.val(courseApplicationData.course_application.course_application_unique_identifier).change()
    },
    onFormSubmitted: function($form) {
      fetchHubspotFormStatus('form3');
    }
  });

  return (
    <>
      <h2>Education and Employment</h2>
      {!(
        courseApplicationData.in_hub_city || courseApplicationData.is_military
      ) && (
        <div className="alert alert-warning">
          You are outside LaunchCode’s service area. Note that your application
          will NOT be considered unless you are a military veteran / active duty
          / reserve / national guard. Reach out to{" "}
          <a href="mailto:enrollment@launchcode.org">
            enrollment@launchcode.org
          </a>{" "}
          if you have questions.
        </div>
      )}
      <div id='course-application'></div>
    </>
  )
};

export default FormPersonalInformation;
